<template>
  <div class="table-search">
    <el-form ref="queryForm" class="formsearch" inline :model="localQuery" @submit.native.prevent>
      <slot name="content"></slot>
      <slot v-if="showMore" name="more-content"></slot>
    </el-form>
    <div class="formbutton">
      <el-button type="primary" size="medium" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      <el-button type="info" plain size="medium" icon="el-icon-refresh" @click="handleReset">重置</el-button>
      <el-button type="text" @click="toggleMore">{{ showMore ? '收起' : '展开' }} <i :class="showMore?'el-icon-top':'el-icon-bottom'"></i></el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableSearch',
  props: {
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      localQuery: { ...this.query },
      showMore: false
    }
  },
  computed: {
    hasMore() {
      return !!this.$slots['more-content']
    }
  },
  methods: {
    handleReset() {
      console.log(this.localQuery, '============')
      this.resetForm('queryForm')
      // console.log(this.localQuery, '============')
      this.$emit('reset')
    },
    handleSearch() {
      this.$emit('search', this.localQuery)
    },
    toggleMore() {
      this.showMore = !this.showMore
    }
  }
}
</script>

<style scoped>
.table-search {
  margin-bottom: -36px;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
.formsearch {
  display: inline-block;
  max-width: 1550px;
}
.formbutton{
  text-align: right;
  padding-right:50px;
}

</style>
